export default __webpack_public_path__ + "static/media/CSS-icon.286a9900.png";